module.exports = __webpack_public_path__ + "static/media/ug.be11ef39.svg";